import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const ligne = { marginTop: 8 };

function libelleStatut(statut) {
  if (statut === 'ok') return 'OK';
  if (statut === 'ok_surveillance') return 'OK avec surveillance';
  if (statut === 'ko') return 'KO';
  if (statut === 'non_applicable') return 'Non applicable';
  return 'A valider';
}

function SyncCamDeploiementResume({ rapport }) {
  if (!rapport) {
    return (
      <Paper style={{ padding: 16 }}>
        <Typography>Aucun rapport a afficher.</Typography>
      </Paper>
    );
  }

  const referenceVersion = rapport.referenceVersion || {};
  const qualification = rapport.qualificationRelease || {};
  const gates = rapport.gatesFonctionnels || [];
  const observation = rapport.observationPostDeploiement || {};

  return (
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6">Apercu avant validation</Typography>
      <Divider style={{ marginTop: 12, marginBottom: 12 }} />

      <Typography style={ligne}><strong>Operateur:</strong> {rapport.operateur || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Version:</strong> {referenceVersion.version || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Commit:</strong> {referenceVersion.commit || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Appareils pilotes:</strong> {qualification.appareilsPilotes || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Notes de qualification:</strong> {qualification.notes || 'Aucune'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Gates fonctionnels SyncCam</Typography>
      {gates.map((gate) => (
        <Typography key={gate.id} style={ligne}>
          {gate.titre}: {libelleStatut(gate.statut)}
        </Typography>
      ))}

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Observation post-deploiement</Typography>
      <Typography style={ligne}>Incidents: {observation.incidents || 'Aucun'}</Typography>
      <Typography style={ligne}>Monitoring: {observation.monitoring || 'Non renseigne'}</Typography>
      <Typography style={ligne}>Heartbeat: {observation.heartbeat || 'Non renseigne'}</Typography>
      <Typography style={ligne}>Convergence: {observation.convergence || 'Non renseignee'}</Typography>
      <Typography style={ligne}>Uploads: {observation.uploads || 'Non renseignes'}</Typography>
      <Typography style={ligne}>Dette runtime: {observation.detteRuntime || 'Non renseignee'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography style={ligne}><strong>Decision finale:</strong> {rapport.decisionFinale || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Justification:</strong> {rapport.commentaireDecision || 'Aucune'}</Typography>
    </Paper>
  );
}

export default SyncCamDeploiementResume;



// WEBPACK FOOTER //
// src/components/deploiements/SyncCamDeploiementResume.js